const getEventTypeOptions = (eventTypes = [], intl) => eventTypes.map((type) => {

  return {
    label: intl.formatMessage({ id: `event-types-${type}` }),
    value: type,
  };
});

export default getEventTypeOptions;
